import { Link } from 'gatsby';
import React from 'react';

export const options = {
  renderNode: {
    ['entry-hyperlink']: (node, children) => {
      const id = node.data?.target?.sys?.id;

      if (id) {
        return (
          <Link sx={{ textDecoration: 'none', color: 'primary' }} to={`/${id}`}>
            {children}
          </Link>
        );
      }

      return <></>;
    },
  },
};
